var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"recommended-age-icon rounded-circle pa-1"},[_vm._v("\n  "+_vm._s(_vm.$t('components.uiComponents.recommendedAgeIcon.ageAndUp', {
      age: _vm.age.toString(),
    }))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }